import preventDefault from "./preventDefault"
import stopImmediatePropagation from "./stopImmediatePropagation"

export default function preventCursorSelectText(elem: HTMLElement): void {
  elem.addEventListener('selectstart', (event) => {
    stopImmediatePropagation(event)
    preventDefault(event)
  })
}
